var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('stock-take-summary-desktop',{attrs:{"id":_vm.id,"savePage":_vm.savePage,"saveTab":_vm.saveTab,"saveSearch":_vm.saveSearch,"saveFilters":_vm.saveFilters,"list-page":"ClinicInventoryStockTake"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }